"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteSerieType = void 0;
/**
 * The KetteSerieType structures chain series according to availability of data and calculations
 */
var KetteSerieType;
(function (KetteSerieType) {
    KetteSerieType["default"] = "default";
    KetteSerieType["eskin"] = "eskin";
    KetteSerieType["twisterband"] = "twisterband";
    KetteSerieType["twisterchain"] = "twisterchain";
    KetteSerieType["triflexR"] = "triflexR";
    KetteSerieType["rxRohr"] = "rxRohr";
    KetteSerieType["rolEchain"] = "rolEchain";
    KetteSerieType["trxe"] = "trxe";
})(KetteSerieType = exports.KetteSerieType || (exports.KetteSerieType = {}));
//# sourceMappingURL=KetteSerieType.js.map